// =============================================================================
// Stepper — indicatore di progresso (4 step)
// =============================================================================

interface Props {
  labels: string[];
  currentIndex: number;
}

const PRIMARY = 'var(--skedulab-public-primary, #10B981)';

export function Stepper({ labels, currentIndex }: Props) {
  return (
    <ol className="flex items-center gap-2 mb-7">
      {labels.map((label, i) => {
        const isDone = i < currentIndex;
        const isCurrent = i === currentIndex;
        const active = isDone || isCurrent;
        return (
          <li key={label} className="flex-1 flex items-center gap-2">
            <div
              className={`w-8 h-8 rounded-full flex items-center justify-center text-xs font-semibold transition-all ${
                active ? 'text-white shadow-sm' : 'bg-gray-100 text-gray-400'
              }`}
              style={
                active
                  ? {
                      background: PRIMARY,
                      ...(isCurrent
                        ? { boxShadow: `0 0 0 4px color-mix(in srgb, ${PRIMARY} 18%, transparent)` }
                        : {}),
                    }
                  : undefined
              }
            >
              {isDone ? '✓' : i + 1}
            </div>
            <span
              className={`text-xs font-medium hidden sm:inline ${
                isCurrent ? 'text-gray-900' : 'text-gray-500'
              }`}
            >
              {label}
            </span>
            {i < labels.length - 1 && (
              <div className="flex-1 h-0.5 rounded-full bg-gray-200 overflow-hidden">
                <div
                  className="h-full rounded-full transition-all"
                  style={{ width: isDone ? '100%' : '0%', background: PRIMARY }}
                />
              </div>
            )}
          </li>
        );
      })}
    </ol>
  );
}
